/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Loading2Inputs */

const en_coinvestments_dataroom_loading2 = /** @type {(inputs: Coinvestments_Dataroom_Loading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading data room`)
};

/**
* | output |
* | --- |
* | "Loading data room" |
*
* @param {Coinvestments_Dataroom_Loading2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_loading2 = /** @type {((inputs?: Coinvestments_Dataroom_Loading2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Loading2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_loading2(inputs)
});
export { coinvestments_dataroom_loading2 as "coInvestments_dataRoom_loading" }